<template>

<div >

 <div class="modal" id="StockReturnProductSearch" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl verybigmodal">
    <div class="modal-content ">
      <div class="modal-header border-success bg-primary text-white">
        <h4 class="modal-title" id="staticBackdropLabel">
            <i class="fas fa-binoculars mr-2" aria-hidden="true"></i>
            RICERCA PRODOTTO </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
           
        <form v-on:submit.prevent="getData()">
        
            <inputSearch  @update="setData"></inputSearch>   
                
            <button  class="btn btn-primary mt-1 mb-1 ml-2">
              <i  class="fas fa-binoculars mr-2" aria-hidden="true"></i>
              CERCA
              <span v-if="spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
            </button>
    
            <alert-box class="mt-1 mb-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

        </form>

        <div class="row">
        <div class="col">     
        <!--    
        <button @click="reset()"  class="btn btn-danger  mt-1 mb-1 mr-2 float-right">
        <i style="color:yellow" class="fas fa-undo mr-2" aria-hidden="true"></i>
        RESET 
        </button>
      -->
        </div>  
        </div>  
 
 

  <div class=" row table-wrapper-scroll-y my-custom-scrollbar ml-1 mr-1">

<table class="table table-hover table-sm table-striped mb-0">
<thead >
  <tr class="table-primary">
    <th scope="col">#</th>
    <th scope="col">ID</th>
    <th scope="col">BRAND</th>
    <th scope="col">CATEGORIA</th>
    
    <th scope="col">CODICE</th>
    <th scope="col">COLORE</th>
    <th scope="col">MISURA</th>
    <th class="text-right" scope="col">ESISTENZA</th>
    
    <th scope="col">DESCRIZIONE</th>
    <th scope="col">REPARTO</th>
    <th scope="col">STAGIONE</th>
    <th class="text-right" scope="col">LISTINO</th>
    <th scope="col">EAN</th>
   
  </tr>
</thead>
<tbody>
  
  <tr data-toggle="tooltip" title="Doppio click seleziona PRODOTTO" class="pointer" v-on:dblclick="setProduct(item)"  v-for="(item, index) in filteredProducts" :key="index">
    <td>{{index+1}}</td>
    <td>{{item.productId}}</td>

    <td>{{item.brand}}</td>
     <td>{{item.category}}</td>
    
    <td><strong>{{item.sku}}</strong></td>
    <td>{{item.color}} </td>
    <td>{{item.size}} </td>        
    <td class="text-right">{{item.qtyStock}} </td>
    
    
    <td>{{item.description}}</td>
    <td>{{item.department}}</td>
    <td>{{item.season}}-{{item.season_year}} </td>
  
    <td class="text-right">{{fmtCurrency(item.price)}}</td>
    <td>{{item.barcode}}</td>
   
  </tr> 
  
  
</tbody>

</table>



</div>  
</div>








<!-- BODY -->
</div>  



  </div> 

   
  </div>
 
</div>



</template>
<script>
import api             from "@/api";

import alertBox          from '@/components/common/AlertBox.vue'
import filterKey         from '@/components/common/FilterKey.vue'
import inputSearch         from '@/components/frontOffice/InputSearch.vue'

import {mapGetters }    from 'vuex';
export default {
   props      : ['supplierId'],
  components  : {alertBox,filterKey,inputSearch},
  data() {
    return {
      input                      : 
      {
        
          id                     : 0,
          search                 : '',
          show                   : true
      },
      product                : {},
      productId              : '',
      sku                    : '',
      barcode                : '',
      items                  : [],
      
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },
      spinner                : false,
      showAll                : true,
      
     
    
     
    }
  },
  computed :{
   
    ...mapGetters(['company','storeId']),
    filteredProducts : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     total : function ()
     {
         let total = 0
         this.filteredProducts.forEach(item=>
          {
            total += item.qtyStock
          })
          return total
     }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        //el.focus();
      }
    }
  },
  mounted: function() {
    
    $('#StockReturnProductSearch').on('shown.bs.modal', function (event) {
    //  $('#inputSearch').trigger('focus');
    })
    
  },
  created: function() {
    //console.log('Route : ',this.route)
    //this.getProductDataList()
   
  },
  methods: {
    //...mapActions(['getProductDataList']),

    
    setFilterKey(value)
    {
        this.filterKey = value
    },
    fmtCurrency(value)
    { 
      return Number(value).toLocaleString('it-IT',{ style: 'decimal',minimumFractionDigits: 2 ,maximumFractionDigits: 2});
    },
  
    setData(data,id)
    {
      this.input.id = id
      this.input.search = data
      
    },
    setProduct(item)
    {
      this.$emit('update',item.barcode)  

    },
    reset()
    {
        this.items = []
       
       

    },
    async getData() {
    
      
      this.msg.title = '' 
    
      this.spinner = true
      this.items   = []
      
      
      
      const data     = {

      'productKey'     : this.input.id,
      'productSearch'  : this.input.search.replace("'",""),
      'companyId'      : this.company.Id,
      'storeId'        : this.storeId,
      'supplierId'     : this.supplierId
      } 

      
      const sp = {'sp': 'spNewSupplierProductsBarcodes'}

      const json    = Object.assign(data, sp)
    

      await api.post(json).then(res => {
        
          if(res.status==200)
            {
              this.items = res.data.recordsets[0]
              
              if(this.items.length==0)
              {
                this.msg.title = 'ATTENZIONE'              
                this.msg.body  = 'DATI INESISTENTI'
                this.msg.type  = 1
                
              }

            }
           else if(res.status==500)
           {
                
                this.msg.title = 'ATTENZIONE ' 
                 this.msg.body  = res.data            
                this.msg.type  = 1
               
               
                    
           } 
           else
            {
                
                this.msg.title = 'ATTENZIONE ' 
                this.msg.body  = res            
                this.msg.type  = 1
                

                 
            } 
          

          }).catch(err => {
              
              console.log(err.message)    

              
          }).finally(() => {
          this.spinner = false
        });



    }
  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 500px;
overflow: auto;
}
.form-check-label{
  cursor: pointer;
}
.pointer:hover
{
  background-color: blue;
  color: white;
  cursor: pointer;
}
.table-wrapper-scroll-y {
display: block;
}

.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}
.btn_1
{
  background-color: #ec7211 !important;
  color : white;
}
.modal-content {
  -webkit-border-radius: 0px !important;
  -moz-border-radius: 0px !important;
  border-radius: 15px !important;
  -webkit-border: 0px !important;
  -moz-border: 15px !important;
  border: 0px !important;
}


.verybigmodal{
  max-width: 75% !important;
  
}
</style>